import { render, staticRenderFns } from "./requestPayment.vue?vue&type=template&id=2999166f&scoped=true&"
import script from "./requestPayment.vue?vue&type=script&lang=js&"
export * from "./requestPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2999166f",
  null
  
)

export default component.exports